// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productQuantityBreakPricingStyles } from "@synd/Overrides/Components/ProductQuantityBreakPricing";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

productQuantityBreakPricingStyles.title = {
    ...fontConfig.smallSingleLine,
    transform: "uppercase",
    weight: fontConfig.weight.semiBold,
};
productQuantityBreakPricingStyles.wrapper = {
    css: css`
        background: ${color("common.ui8")};
        border-radius: 8px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};
productQuantityBreakPricingStyles.note = {
    ...fontConfig.xSmall,
    css: css`
        margin-top: 4px;
        font-style: italic;
    `,
};
productQuantityBreakPricingStyles.row = {
    css: css`
        display: flex;
        justify-content: space-between;
        column-gap: 8px;
    `,
};
productQuantityBreakPricingStyles.breakPrice = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.bold,
};

productQuantityBreakPricingStyles.breakQty = {
    ...fontConfig.xSmallSingleLine,
};

productQuantityBreakPricingStyles.breakUOM = {
    ...fontConfig.xxSmallSingleLine,
    weight: fontConfig.weight.regular,
};
